import React, { useState, useMemo, useEffect, useCallback, useRef } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@mui/material/Tooltip';
import CallIcon from "@mui/icons-material/Call"; // Ícone de telefone do Material UI

import AppBar from '@mui/material/AppBar';
import { Snackbar } from '@material-ui/core';
import { Menu } from '@mui/material';

import Cookies from 'js-cookie';
import { MenuItem, Select, InputLabel, FormControl, IconButton } from '@mui/material';
import {
    FormLabel,
    RadioGroup,
    Radio,
} from '@material-ui/core';

import { useHistory } from "react-router-dom";
import moment from 'moment';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, Box } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';



import {
    MaterialReactTable
} from 'material-react-table';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import BuildIcon from '@mui/icons-material/Build';
import Switch from '@mui/material/Switch';
import SettingsIcon from '@mui/icons-material/Settings';
import PowerIcon from '@mui/icons-material/Power';
import PowerOffIcon from '@mui/icons-material/Power';



import api from '../../../../../../services/api';


import NavegadorGestao from "../../../../../../components/NavBarGestao";
import SipCallComponent from '../SipCallComponent/index'


import switch_off from '../../../../../../assets/imgs/switch-off.png';
import switch_on from '../../../../../../assets/imgs/switch-on.png';


import mini_icone_carro from '../../../../../../assets/imgs/mini_icone_carro.png';

import mini_icone_moto from '../../../../../../assets/imgs/mini_icone_moto.png';

import icone_origem from '../../../../../../assets/imgs/icone_origem.png';
import icone_destino from '../../../../../../assets/imgs/icone_destino.png';
import icone_parada from '../../../../../../assets/imgs/icone_parada.png';

import icone_call from '../../../../../../assets/imgs/icone_call.png';


import cabo_conectado from '../../../../../../assets/imgs/cabo_conectado.png';
import cabo_desconectado from '../../../../../../assets/imgs/cabo_desconectado.png';
import cabo_internet from '../../../../../../assets/imgs/cabo_internet.png';
import cabo_sem_internet from '../../../../../../assets/imgs/cabo_sem_internet.png';

import wifi_conectado from '../../../../../../assets/imgs/cabo_conectado.png';

import modem_conectado from '../../../../../../assets/imgs/modem_conectado.png';
import modem_desconectado from '../../../../../../assets/imgs/modem_desconectado.png';
import modem_internet from '../../../../../../assets/imgs/cabo_internet.png';
import modem_sem_internet from '../../../../../../assets/imgs/cabo_sem_internet.png';

import icone_pgm from '../../../../../../assets/imgs/icone_pgm.png';
import icone_corneta from '../../../../../../assets/imgs/corneta.png';

import icone_play from '../../../../../../assets/imgs/play.png';


import icone_medidor from '../../../../../../assets/imgs/icone_medidor.png';

import icone_subestacao from '../../../../../../assets/imgs/icone_subestacao.png';
import icone_casa from '../../../../../../assets/imgs/icone_casa.png';
import icone_loja from '../../../../../../assets/imgs/icone_loja.png';
import icone_central from '../../../../../../assets/imgs/icone_central.png';

import icone_instalacoes from '../../../../../../assets/imgs/icone_instalacoes.png';
import icone_equipamentos from '../../../../../../assets/imgs/icone_equipamentos.png';

import icone_armar_stay from '../../../../../../assets/imgs/armar_stay.png';
import icone_armar_away from '../../../../../../assets/imgs/armar_away.png';
import icone_desarmar from '../../../../../../assets/imgs/desarmar.png';
import globalConfig from '../../../../../../configs/globalConfigs';





import {
    GoogleMap,
    Marker,
    LoadScript,
    OverlayView,
    StandaloneSearchBox,
    DirectionsService,
    DirectionsRenderer,
    DistanceMatrixService,
     Circle, Polygon, Polyline
} from "@react-google-maps/api";

import "./MapPage.css";
import alarmeAudio from '../../../../../../assets/mp3/alarme.mp3';





export default function CornetaComponent(props) {


    const { lat, lng, tipo, onClick, status, equipamento, perimetro, id_instalacao, flag, id_sigma, useNativeCall, setUseNativeCall, sipStatus, activeCallRamal, onSipCall, onSipHangup } = props;
    const tempoInativo = 3;

    // Dark mode state and theme config
    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode') || Cookies.get('tema');
        return saved === 'true' || saved === 'dark';
    });

    useEffect(() => {
        const handleThemeChange = () => {
            const saved = Cookies.get('darkMode') || Cookies.get('tema');
            setDarkMode(saved === 'true' || saved === 'dark');
        };

        const intervalId = setInterval(handleThemeChange, 1000);
        window.addEventListener('storage', handleThemeChange);
        window.addEventListener('themeChange', handleThemeChange);
        window.addEventListener('darkModeChanged', handleThemeChange);
        window.addEventListener('temaChanged', handleThemeChange);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('storage', handleThemeChange);
            window.removeEventListener('themeChange', handleThemeChange);
            window.removeEventListener('darkModeChanged', handleThemeChange);
            window.removeEventListener('temaChanged', handleThemeChange);
        };
    }, []);



    const [larguraOriginal, setLarguraOriginal] = useState(0);

    const [limiar, setLimiar] = useState(900);
    const [openLogTable, setOpenLogTable] = useState(false);



    function checkDimenssoes() {
        var largura = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;
        var altura = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;

        setLarguraOriginal(largura);

    }

    window.addEventListener('resize', function (event) {
        checkDimenssoes();
    });


    useEffect(() => {



        checkDimenssoes();



    }, []);


    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');






    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };


    const [logsPgm, setLogsPgm] = useState([]);
    const [limit, setLimit] = useState(200);


    function processarIcone(tipo) {
        if (tipo === 0) {
            return icone_pgm;
        } else if (tipo === 10) {
            return icone_medidor;
        } else if (tipo === 70) {
            return icone_central;
        } else if (tipo === 30) {
            return icone_pgm;
        } else if (tipo === 120) {
            return icone_corneta;
        }
    }





    async function handleClickCorneta(comando) {

        console.log("handleClickPgm")
        try {
            const cadastro = {};
            const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
            const url = `/v1/protected/modulopgm/tarefas/criarporareatecnica/` + Cookies.get("id_usuario") + "/" + equipamento.modulo_pgm.id_modulo_pgm + "/" + comando;
            const response = await api.get(url, { headers });

            if (response.data) {
                setSnackbarMessage('Comando Enviado!');
                setSnackbarSeverity('success');
                setSnackbarOpen(true);


            }



        } catch (error) {
            setSnackbarMessage('Erro ao enviar comando');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            console.error("Erro ao enviar o comando:", error);
        }
    }




    return (
        <>
            {flag === 1 ? (
                <div style={{
                    backgroundColor: darkMode ? '#0f172a' : '#f8fafc',
                    borderRadius: '16px',
                    padding: '24px',
                    margin: '8px 0',
                    width: '100%',
                    fontFamily: '"Rajdhani", "Roboto", "Segoe UI", sans-serif',
                    boxShadow: darkMode ? '0 10px 40px rgba(0,0,0,0.5)' : '0 10px 40px rgba(0,0,0,0.08)',
                    border: darkMode ? '1px solid #1e293b' : '1px solid #e2e8f0',
                }}>
                    {/* HEADER IOT */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: darkMode ? '1px solid #1e293b' : '1px solid #e2e8f0', paddingBottom: '16px', marginBottom: '24px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <img src={processarIcone(tipo)} alt="icon" style={{ width: '48px', height: '48px', position: 'relative', zIndex: 2, filter: darkMode ? 'invert(1)' : 'none' }} />
                                <div style={{
                                    position: 'absolute', width: '56px', height: '56px', borderRadius: '50%',
                                    backgroundColor: '#3b82f6', opacity: 0.2, animation: 'pulse 2s infinite', zIndex: 1
                                }} />
                            </div>
                            <div>
                                <Typography style={{ fontWeight: 800, fontSize: '1.4rem', letterSpacing: '0.5px', color: darkMode ? '#f8fafc' : '#0f172a', lineHeight: 1.2 }}>
                                    CORNETA KHOMP <span style={{ color: '#3b82f6', fontSize: '0.8rem', backgroundColor: 'rgba(59, 130, 246, 0.1)', padding: '2px 8px', borderRadius: '12px', verticalAlign: 'middle', marginLeft: '8px' }}>SISTEMA DE ÁUDIO</span>
                                </Typography>
                                <Typography style={{ fontSize: '0.85rem', color: darkMode ? '#94a3b8' : '#64748b', fontFamily: 'monospace', marginTop: '4px' }}>
                                    ID DO DISPOSITIVO: {equipamento?.id_equipamento || 'N/A'}
                                </Typography>
                            </div>
                        </div>
                    </div>

                    {/* DASHBOARD MODULES */}
                    <Grid container spacing={3}>
                        {/* AUDIO ALERTS PANEL */}
                        <Grid item xs={12} md={6}>
                            <div style={{
                                backgroundColor: darkMode ? '#1e293b' : '#ffffff', borderRadius: '12px', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0',
                                height: '100%', position: 'relative', overflow: 'hidden', display: 'flex', flexDirection: 'column',
                                boxShadow: darkMode ? 'inset 0 2px 10px rgba(0,0,0,0.2)' : '0 2px 10px rgba(0,0,0,0.02)'
                            }}>
                                <div style={{ backgroundColor: darkMode ? '#0f172a' : '#f8fafc', padding: '10px 16px', fontSize: '0.75rem', fontWeight: 800, letterSpacing: '1px', color: darkMode ? '#cbd5e1' : '#475569', borderBottom: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><VolumeUpIcon fontSize="small"/> CANAIS DE NOTIFICAÇÃO </span>
                                    <span style={{ color: '#ef4444', fontSize: '0.7rem', animation: 'pulse 2s infinite' }}>GATILHOS RÁPIDOS</span>
                                </div>
                                <div style={{ padding: '16px', flex: 1, display: 'flex', alignItems: 'center' }}>
                                    <Grid container spacing={2}>
                                        {[
                                            { id: 6, name: 'Audio 1' },
                                            { id: 7, name: 'Audio 2' },
                                            { id: 8, name: 'Audio 3' },
                                            { id: 9, name: 'Audio 4' }
                                        ].map((audio) => (
                                            <Grid item xs={6} key={audio.id}>
                                                <Button 
                                                    fullWidth
                                                    onClick={() => handleClickCorneta(audio.id)}
                                                    style={{
                                                        backgroundColor: darkMode ? '#0f172a' : '#f8fafc',
                                                        border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0',
                                                        borderRadius: '8px', padding: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', 
                                                        transition: 'all 0.2s', color: darkMode ? '#f8fafc' : '#0f172a', textTransform: 'none',
                                                        boxShadow: '0 2px 5px rgba(0,0,0,0.05)'
                                                    }}
                                                    onMouseOver={(e) => {
                                                        e.currentTarget.style.borderColor = '#ef4444';
                                                        e.currentTarget.style.boxShadow = '0 0 10px rgba(239, 68, 68, 0.2)';
                                                    }}
                                                    onMouseOut={(e) => {
                                                        e.currentTarget.style.borderColor = darkMode ? '#334155' : '#e2e8f0';
                                                        e.currentTarget.style.boxShadow = '0 2px 5px rgba(0,0,0,0.05)';
                                                    }}
                                                >
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <img src={icone_play} alt="Play" style={{ width: '24px', height: '24px', filter: darkMode ? 'brightness(1.5)' : 'none' }} />
                                                        <span style={{ fontSize: '0.9rem', fontWeight: 700 }}>{audio.name}</span>
                                                    </div>
                                                </Button>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </div>
                            </div>
                        </Grid>

                        {/* SIP CALL PANEL */}
                        <Grid item xs={12} md={6}>
                            <div style={{
                                backgroundColor: darkMode ? '#1e293b' : '#ffffff', borderRadius: '12px', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0',
                                height: '100%', position: 'relative', display: 'flex', flexDirection: 'column'
                            }}>
                                <div style={{ backgroundColor: darkMode ? '#0f172a' : '#f8fafc', padding: '10px 16px', fontSize: '0.75rem', fontWeight: 800, letterSpacing: '1px', color: darkMode ? '#cbd5e1' : '#475569', borderBottom: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><CallIcon fontSize="small"/> INTERFONE SIP </span>
                                    <span style={{ color: sipStatus === 'Registered' ? '#10b981' : '#f59e0b', fontSize: '0.7rem' }}>{sipStatus === 'Registered' ? 'REGISTRADO' : (sipStatus || 'AGUARDANDO')}</span>
                                </div>
                                <div style={{ padding: '16px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                                    <Button
                                        variant="contained"
                                        startIcon={<CallIcon />}
                                        onClick={() => {
                                            const ramal = equipamento.ramal;
                                            const usuario = Cookies.get('usuario');
                                            window.dispatchEvent(new CustomEvent('open-sip-call', { detail: { ramal, usuario } }));
                                        }}
                                        style={{
                                            backgroundColor: "#00C853",
                                            color: "#ffffff",
                                            fontWeight: "bold",
                                            textTransform: "none",
                                            padding: "12px 24px",
                                            borderRadius: "24px",
                                            boxShadow: "0 4px 12px rgba(0, 200, 83, 0.35)",
                                            fontSize: "0.95rem"
                                        }}
                                    >
                                        Chamar Corneta ({equipamento.ramal || 'Sem ramal'})
                                    </Button>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            ) : (
                <Grid container direction="row" justifyContent="center" align="center" item xs={3} style={{ padding: 1, margin: 0 }}>
                    <Grid container direction="row" justifyContent="center" align="center" item xs={12}>
                        <Grid item xs={12}>
                            <img alt={"icone"} style={{ textAlign: 'center', width: '40px', height: '40px', filter: darkMode ? 'invert(1)' : 'none' }} src={processarIcone(tipo)} />
                        </Grid>
                    </Grid>
                    <Grid container direction="column" justifyContent="center" align="center" item xs={12} style={{ padding: 1, marginTop: '8px' }}>
                        <IconButton
                            onClick={() => {
                                const ramal = equipamento.ramal;
                                const usuario = Cookies.get('usuario');
                                window.dispatchEvent(new CustomEvent('open-sip-call', { detail: { ramal, usuario } }));
                            }}
                            style={{
                                backgroundColor: "#00C853",
                                color: "#ffffff",
                                padding: 8,
                                boxShadow: "0 2px 8px rgba(0, 200, 83, 0.4)"
                            }}
                            title={`Chamar ramal ${equipamento.ramal}`}
                        >
                            <CallIcon fontSize="small" />
                        </IconButton>
                    </Grid>
                </Grid>
            )}

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                message={snackbarMessage}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                ContentProps={{
                    'aria-describedby': 'message-id',
                    style: {
                        backgroundColor: snackbarSeverity === 'success' ? '#4caf50' : '#f44336',
                        marginTop: '60px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        border: '1px solid black',
                        borderRadius: '4px',
                        padding: '10px',
                        zIndex: 555,
                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                    }
                }}
            />
        </>
    );
}

